const SilverSambaFollow = {
    name: "Silver Samba",
    bpm: 108,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default SilverSambaFollow;